'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {

    case 'GET_STUDENTS':
      return action.payload.students.reduce(function (state, student) {
        return state.updateIn([action.fid, student.id], function (data) {
          return (0, _immutable.fromJS)(_extends({}, (data || (0, _immutable.fromJS)({})).toJS(), { registered: student.registered }));
        });
      }, state);

    case 'GET_REGISTERED_DATA_FOR_PERSON':
      return action.payload.reduce(function (state, p) {
        return state.updateIn([action.feis_id, action.person_id], function (data) {
          return (0, _immutable.fromJS)(_extends({}, (data || (0, _immutable.fromJS)({})).toJS(), p));
        });
      }, state);

    case 'GET_FEIS_PARTICIPANT':
      return state.updateIn([action.fid, action.pid], function (data) {
        return (0, _immutable.fromJS)(_extends({}, (data || (0, _immutable.fromJS)({})).toJS(), { registered: action.payload.registered }));
      });

    case 'GET_SCORESHEET':
      return action.payload.reduce(function (state, data) {
        return state.setIn([action.feis_id, data.person, 'competitor'], data.competitor);
      }, state);

    case 'GET_ALL_EVENT_SCORES':
      var scores = action.payload.map(function (adj) {
        return adj.scores;
      });
      return scores.flat().reduce(function (state, score) {
        return state.setIn([action.feis_id, score.person, 'competitor'], score.competitor);
      }, state);

    case 'GET_UNPAID_COMPETITORS_FOR_FEIS':
      return action.payload.reduce(function (state, competitor) {
        return state.updateIn([action.feis_id, competitor.id], function (data) {
          return (0, _immutable.fromJS)(_extends({}, (data || (0, _immutable.fromJS)({})).toJS(), { registered: true, paid: false }));
        });
      }, state);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/persons/index.js
// module id = 699
// module chunks = 0